import camelize from 'camelcase-keys-deep';

export default class WebTransaction {
  constructor(data) {
    const props = camelize(data);
    Object.assign(this, props);
  }

  payment() {
    return this.env().Payment.getById(this.paymentId);
  }
}
